import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { setLenis, getLenis } from "@/lib/lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";
import Home from "@/pages/Home";
import Punaises from "@/pages/Punaises";
import Cafards from "@/pages/Cafards";
import Tarifs from "@/pages/Tarifs";
import Protocole from "@/pages/Protocole";
import ProtocoleCafards from "@/pages/ProtocoleCafards";
import Cgv from "@/pages/Cgv";
import CityPunaises from "@/pages/CityPunaises";
import ZoneIntervention from "@/pages/ZoneIntervention";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import Contact from "@/pages/Contact";
import Pros from "@/pages/Pros";
import CookieBanner from "@/components/CookieBanner";
import LegacyRedirect from "@/components/LegacyRedirect";
import Hotels from "@/pages/Hotels";
import { AdminProvider } from "@/admin/AdminContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDevisForm from "@/pages/admin/AdminDevisForm";
import AdminDevisDetail from "@/pages/admin/AdminDevisDetail";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const lenis = getLenis();
        if (lenis) {
            lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

const Shell = () => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <>
            <ScrollToTop />
            {!isAdmin && <Navbar />}
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/punaises-de-lit" element={<Punaises />} />
                    <Route path="/punaises-de-lit/:slug" element={<CityPunaises />} />
                    <Route path="/zone-intervention" element={<ZoneIntervention />} />
                    <Route path="/cafards" element={<Cafards />} />
                    <Route path="/tarifs" element={<Tarifs />} />
                    <Route path="/protocole-punaises" element={<Protocole />} />
                    <Route path="/protocole-cafards" element={<ProtocoleCafards />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
                    <Route path="/cgv" element={<Cgv />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pros" element={<Pros />} />
                    <Route path="/hotels" element={<Hotels />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/devis/nouveau" element={<AdminDevisForm />} />
                    <Route path="/admin/devis/:id/modifier" element={<AdminDevisForm />} />
                    <Route path="/admin/devis/:id" element={<AdminDevisDetail />} />
                    <Route path="*" element={<LegacyRedirect />} />
                </Routes>
            </main>
            {!isAdmin && <Footer />}
            {!isAdmin && <StickyCallButton />}
            {!isAdmin && <CookieBanner />}
        </>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
        setLenis(lenis);
        return () => lenis.destroy();
    }, []);

    return (
        <div className="App bg-white text-night min-h-screen">
            <BrowserRouter>
                <AdminProvider>
                    <Shell />
                </AdminProvider>
                <Toaster position="top-center" richColors />
                <div className="grain-overlay" aria-hidden="true" />
            </BrowserRouter>
        </div>
    );
}

export default App;
